/**
 * AccountModal Component
 *
 * Handles account settings modal including:
 * - Profile picture display and change
 * - Reset password functionality
 * - Account management actions
 */

import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { logout } from '../../../store/user'
import '../../../assets/stylesheets/account-modal.css'
import profilePicture from '../../../assets/images/profile-picture5.png'

const AccountModal = ({ isVisible, onClose }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [selectedImage, setSelectedImage] = useState(profilePicture)

  const handleResetPassword = () => {
    dispatch(logout())
    onClose()
    navigate('/auth')
  }

  const handleImageChange = e => {
    if (e.target.files && e.target.files[0]) {
      let img = e.target.files[0]
      setSelectedImage(URL.createObjectURL(img))
    }
  }

  const handleOverlayClick = e => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  if (!isVisible) return null

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h5 className="modal-title">Account Settings</h5>
        </div>
        <div className="modal-body2">
          <img src={selectedImage} alt="Profile" className="profile-picture" />
          <div className="buttons">
            <input
              type="file"
              onChange={handleImageChange}
              id="imageInput"
              hidden
            />
            <button className="button sec" onClick={handleResetPassword}>
              Reset Password
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountModal
